import {
  Grid,
  InputAdornment,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { getDegreeLevels, getTrainingType, getTrainingDomains } from '@webapps/business';
import {
  Button,
  FormikAutocompletePx,
  FormikTextFieldPx,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useState } from 'react';

import Modal from 'components/Modal';
import AddPartner from './AddPartner';

const FilterPartners = ({ formik = {}, partners, refetch, accept }) => {
  const {
    classes,
    css,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const [openInternalPartner, setOpenInternalPartner] = useState(false);

  const { data: { content: trainingDomains = [] } = {} } = useQuery(getTrainingDomains, {
    key: 'allTrainingDomains',
  });

  const { data: degreeLevels = [] } = useQuery(getDegreeLevels, {
    key: 'allDegreeLevels',
  });

  const { data: trainingTypes = [] } = useQuery(getTrainingType, {
    key: 'allTrainingTypes',
  });

  return (
    <>
      <div
        className={css({
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px', // espacement entre les éléments
          '@media (max-width: 768px)': {
            flexDirection: 'column',
          },
        })}
      >
        {/* Champ Nom de l'école */}
        <div className={css({ flex: '1 1 0%', minWidth: '200px' })}>
          <FormikTextFieldPx
            fullWidth
            formik={formik}
            variant="outlined"
            borderRadius={50}
            name="keyword"
            label="Nom de l'école"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search style={{ color: '#5D75A8' }} />
                </InputAdornment>
              ),
            }}
          />
        </div>

        {/* Champ Domaine(s) d'étude(s) */}
        <div className={css({ flex: '1 1 0%', minWidth: '200px' })}>
          <FormikAutocompletePx
            formik={formik}
            fullWidth
            getOptionLabel={(option) => option.label || ''}
            label="Domaine(s) d'étude(s)"
            name="trainingDomains"
            options={trainingDomains}
            pathValue="id"
            value={trainingDomains.find((trainingDomain) => trainingDomain.id === formik.values.trainingDomains) || null}
          />
        </div>

        {/* Champ Niveau(s) d'étude(s) */}
        <div className={css({ flex: '1 1 0%', minWidth: '200px' })}>
          <FormikAutocompletePx
            formik={formik}
            fullWidth
            getOptionLabel={(option) => option.label || ''}
            label="Niveau(s) d'étude(s)"
            name="degreeLevels"
            options={degreeLevels}
            pathValue="id"
            value={degreeLevels.find((degreeLevel) => degreeLevel.id === formik.values.degreeLevels) || null}
          />
        </div>

        {/* Champ Type de formation */}
        {accept && (
          <div className={css({ flex: '1 1 0%', minWidth: '200px' })}>
            <FormikAutocompletePx
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              label="Type de formation"
              name="trainingTypes"
              options={trainingTypes}
              pathValue="id"
              value={trainingTypes.find((trainingType) => trainingType.id === formik.values.trainingTypes) || null}
            />
          </div>
        )}

        {/* Bouton Rechercher un partenariat */}
        {partners.length > 0 && (
          <div className={css({ minWidth: '200px', display: 'flex' })}>
            <Button
              color="primary"
              onClick={() => setOpenInternalPartner(true)}
              variant="contained"
              disableElevation={true}
              fullWidth
              className={classes.btn}
            >
              Rechercher un partenariat
            </Button>
          </div>
        )}
      </div>

      <Modal
        onCancel={() => setOpenInternalPartner(false)}
        open={openInternalPartner}
        title="Rechercher un partenariat"
        width="1200px"
      >
        <AddPartner
          onClose={() => setOpenInternalPartner(false)}
          refetch={refetch}
        />
      </Modal>
    </>
  );
};

const styles = ({ spacing }) => ({
  container: {
    columnGap: 10,
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column',
      columnGap: 0,
      rowGap: 10,
    },
  },
});

export default FilterPartners;
